import { gql } from 'graphql-request';

export const GET_STAFF_INCOMING_INVITES_COUNT = gql`
  query CoreEmployeeInvitations {
    coreEmployeeInvitations {
      count(filter: { isIncoming: true, statuses: sent })
    }
  }
`;
